module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "fronthead"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/docimages/image1.jpg",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "topbot"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/005_list#list"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/007_acknow#acknow"
    }
  }, [_vm._v("ACKNOWLEDGEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/008_prologue#prologue"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/009_c1#c1"
    }
  }, [_vm._v("1 I AM A SCOTTISH TRAVELLER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/010_c2#c2"
    }
  }, [_vm._v("2 A VERY LONG DRIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/011_c3#c3"
    }
  }, [_vm._v("3 MANCHESTER • SAVING JEANNIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/012_c4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 I CAN FLY!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/013_c5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 JOEY’S BRAINWORK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/014_c6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 MURDER IN CLOVER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/015_c7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 THE HUNTRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/016_c8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 OUR PRAYER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/017_c9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 BUS-BOOT BED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/018_c10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 THE MIXI RABBIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/019_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 LOCHGILPHEAD MONKEY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/020_c12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 MOUDIE’S FATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/021_c13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 THE PIPER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/022_c14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 GLENCOE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/023_c15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 TINY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/024_c16#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 JAMIE’S REST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/025_c17#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 BALQUHIDDER VISIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/026_c18#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 THE BABYSITTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/027_c19#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 THE LIVING NIGHTMARE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/028_c20#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 NEEP HEID")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/029_c21#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A FALLEN MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/030_c22#c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 A NATURAL LOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/031_c23#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 GUNFIGHT AT ‘OK, YER A’ DEED NOO!’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/032_c24#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 THE SHEPHERDESS AND HER WEE DUG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/033_c25#c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 KIRKCALDY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/034_c26#c26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 ONE COLD NIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/035_c27#c27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 ARRAN SUMMER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/036_c28#c28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 SCHOOL BULLIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/037_c29#c29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 MAGGIE-ELLEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/038_c30#c30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 ARMADALE MARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/039_c31#c31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 THE BEST TABLET IN THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/040_c32#c32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 SCOTIA’S BAIRN")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/041_glo#glo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY OF UNFAMILIAR WORDS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35bf4ccc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/005_toc.vue
// module id = 69
// module chunks = 0